<template>
    <!-- Ecommerce Sidebar Starts -->
    <div class="sidebar-shop" v-show="this.authenticatedUserCheckoutStore.checkoutIsActive === 0" >
        <div class="card">
            <div class="card-body">
                <!-- Price Slider starts -->
                <div class="price-slider">
                    <h6 class="filter-title">
                        Price Range
                    </h6>
                    <div class="price-slider">
                        <div class="range-slider mt-2" ref="priceRange"></div>
                    </div>
                </div>
                <!-- Price Range ends -->

                <!-- Brands starts -->
                <div class="brands">
                    <h6 class="filter-title">Banks</h6>
                    <ul class="list-unstyled brand-list">
                        <li v-for="bank in authenticatedUserCheckoutStore.banks">
                            <div class="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    name="bank"
                                    :id="bank.card_id"
                                    v-model="authenticatedUserCheckoutStore.selectedCards"
                                    :value="bank.bank_name"
                                />
                                <label class="custom-control-label" :for="bank.card_id">
                                    {{ bank.bank_name }}
                                </label>
                            </div>
                            <span>{{ bank.count }}</span>
                        </li>
                    </ul>
                </div>
                <!-- Brand ends -->

                <!-- Clear Filters Starts -->
                <div id="clear-filters">
                    <button type="button" @click="clearFilter" class="btn btn-block btn-primary">Clear All Filters</button>
                </div>
                <!-- Clear Filters Ends -->
            </div>
        </div>
    </div>
    <!-- Ecommerce Sidebar Ends -->
</template>

<script>
    import noUiSlider from 'nouislider'
    import { useAuthenticatedUserCheckoutStore } from '../stores/AuthenticatedUserCheckoutStore.js'
    import { round } from 'mathjs'
    export default {
        setup(props) {
            return {
                authenticatedUserCheckoutStore: useAuthenticatedUserCheckoutStore()
            }
        },
        mounted() {
            let $this = this;
            noUiSlider.create(this.$refs.priceRange, {
                start: [
                    round($this.authenticatedUserCheckoutStore.minPrice),
                    round($this.authenticatedUserCheckoutStore.maxPrice)
                ],
                direction: 'ltr',
                connect: true,
                tooltips: [true, true],
                // format: wNumb({
                // decimals: 0
                // }),
                range: {
                    min: round($this.authenticatedUserCheckoutStore.minPrice),
                    max: round($this.authenticatedUserCheckoutStore.maxPrice)
                }
            });
            $this.$refs.priceRange.noUiSlider.on('update', function (values, handle) {
                $this.authenticatedUserCheckoutStore.range.min = values[0];
                $this.authenticatedUserCheckoutStore.range.max = values[1];
            });
        },
        methods: {
            clearFilter() {
                this.$refs.priceRange.noUiSlider.reset();
                this.authenticatedUserCheckoutStore.selectedCards.length = 0;
                this.authenticatedUserCheckoutStore.search = '';
            }
        }
    }
</script>
